var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { "is-modified": _vm.isModified, label: "会員登録時期の指定" } },
    [
      _c("term-select", {
        attrs: {
          "selected-option": _vm.selectedOption,
          from: _vm.from,
          to: _vm.to,
          "date-label": "会員登録日",
        },
        on: {
          "update:selectedOption": function ($event) {
            return _vm.$emit("update:selectedOption", $event)
          },
          "update:from": function ($event) {
            return _vm.$emit("update:from", $event)
          },
          "update:to": function ($event) {
            return _vm.$emit("update:to", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }